import React from 'react';

interface IProps {
  text: string;
}

export const SectionHeader = (props: IProps) => {
  return (
    <h3 className="mb-4 py-4 text-xl font-semibold underline">{props.text}</h3>
  );
};
